export const SET_LOGIN = "SET_LOGIN";
export const SET_LOGOUT = "SET_LOGOUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";